 <div class="header"
      data-automation-e2e-selector="header"
      [ngClass]="{'unread': (unseen | async) }"
      *ngIf="!(loading | async) && !!(eventToShow | async)">
    {{formatTime((eventToShow | async).releasedAt)}}
    <span class="textDefault">
        <span class="highlight"
              data-automation-e2e-selector="event">{{(eventToShow | async).name}}</span>
    </span>
</div>
<div class="header"
     *ngIf="!(loading | async) && !(eventToShow | async)">
    No Data Available
</div>
<div class="header"
     *ngIf="loading | async">
    Loading...
</div>